import styled from '@emotion/styled'
import { Text, Box } from 'theme-ui'

import { WithTheme } from '../../../setup'
import { listReset } from '../../../common/Mixins'
import media from '../../../common/MediaQueries'

export const NumbersListStyled = styled.div`
  ${listReset}
  @media ${media.phone} {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 4rem);
    margin: -2rem 0 -2rem -2rem;
  }
`

export const NumbersListItemStyled = styled(Box)<WithTheme>`
  > * {
    max-width: 16.25rem;
    margin: 0 auto;
  }

  &:not(:first-of-type) {
    margin-top: 2rem;
  }

  @media ${media.phone} {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 2rem;

    &:not(:first-of-type) {
      margin-top: 0;
    }

    &:not(:first-of-type)::before {
      position: absolute;
      display: block;
      content: '';
      width: 1px;
      height: 100%;
      max-height: 8.75rem;
      background-color: ${({ theme }) => theme.colors.gray};
      left: 0;
      top: 2rem;
    }
  }
`

export const NumbersTitleStyled = styled(Text)``
